import { Component, OnInit, Input, Output, EventEmitter, ViewChild, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AguaBuscaCuentas, AguaBuscaCuentasInput, CatAguaZonas, CatCalles, CatTipoServicios, CatTipoUsos, ParametroJasper, AuxJasper } from '../../entidades/entidades';
import { AguaBuscaCuentasService } from "../../servicios/agua-busca-cuentas.service";
import { AguasService } from "../../servicios/aguas.service";
import { Aguas } from "../../entidades/entidades";
import Utils from "../../shared/utilerias/utils";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";

import { CatColoniasService } from '../../servicios/cat-colonias.service';
import { CatDelegacionesService } from "app/servicios/cat-delegaciones.service";
import { CatColonias, CatDelegaciones } from '../../entidades/entidades';
import { CatTipoServiciosService } from "app/servicios/cat-tipo-servicios.service";
import { CatTipoUsosService } from "app/servicios/cat-tipo-usos.service";
import { CatAguaZonasService } from "app/servicios/cat-agua-zonas.service";
import { CatCallesService } from "app/servicios/cat-calles.service";
import { Dropdown } from "primeng/dropdown";


declare var $: any;

@Component({
  selector: 'app-agua-busca-cuentas-grid',
  templateUrl: './agua-busca-cuentas-grid.component.html',
  styleUrls: ['./agua-busca-cuentas-grid.component.css']
})
export class AguaBuscaCuentasGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  aguaBuscaCuentasForm: FormGroup;
  aguaBuscaCuentasTable: AguaBuscaCuentas;
  datosAguaCuenta = new AguaBuscaCuentas();
  catColonias: CatColonias[] = [];
  catDelegaciones: CatDelegaciones[] = [];
  catCalles: CatCalles[]=[];
  catTipoServicios: CatTipoServicios[] = [];
  catTipoUsos: CatTipoUsos[] = [];
  catAguaZonas: CatAguaZonas[] = [];
  catColonia = new CatColonias();
  auxColonias: string;
  auxDelegacion: number;
  auxCalle: number;
  auxTipoServicios: number;
  auxTipoUsos: number;
  auxAguaZonas: number;
  @Input() flagPagoEnLinea: boolean = false;
  public auxJasper: AuxJasper;
  public progressBar: boolean = false;
  btnImprimir: boolean = false;

  @Input("aguaBuscaCuentasInput") aguaBuscaCuentasInput: AguaBuscaCuentas;
  @Input("aguaBuscaCuentas") aguaBuscaCuentas: AguaBuscaCuentasInput;
  @Input() mostrarCuenta: boolean = true;
  @Input() busquedaOnChanges: boolean = false; 
  
  @Output("aguasOutput") aguasOutput: EventEmitter<number>;
  
  @ViewChild('dropDownColonia')  dropDownColonia: Dropdown;
  @ViewChild('dropDownDelegacion')  dropDownDelegacion: Dropdown;
  @ViewChild('dropDownCalle')  dropDownCalle: Dropdown;
  @ViewChild('dropDownCatServicios')  dropDownCatServicios: Dropdown;
  @ViewChild('dropDownCatUsos')  dropDownCatUsos: Dropdown;
  @ViewChild('dropDownRutas')  dropDownRutas: Dropdown;


  buscando: boolean = false;
  public tableWidget: any;
  constructor(
    private formBuilder: FormBuilder,
    private aguasService: AguasService,
    private aguaBuscaCuentasService: AguaBuscaCuentasService,
    private catColoniasService: CatColoniasService,
    private catTipoServiciosService: CatTipoServiciosService,
    private CatTipoUsosService: CatTipoUsosService,
    private catAguaZonasService: CatAguaZonasService,
    private catDelegacionesService: CatDelegacionesService,
    private catCallesService: CatCallesService,
  ) {
    this.aguasOutput = new EventEmitter();
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

    if (changes.aguaBuscaCuentasInput.currentValue && this.busquedaOnChanges ) {
      console.log('entra al if');
      this.aguaBuscaCuentasInput = changes.aguaBuscaCuentasInput.currentValue;
      this.ngAfterViewInit();
    } else if (!changes.aguaBuscaCuentasInput.currentValue && this.busquedaOnChanges ) {
      console.log('entra al else');
      this.aguaBuscaCuentasInput = null;
      this.aguaBuscaCuentasTable = null;
     
    }
    

  }

  ngOnInit() {
  
    
    this.aguaBuscaCuentasTable = null;
    this.catColonias = null;
    this.catCalles = null;
    this.catDelegaciones = null;
    this.catTipoServicios = null;
    this.catTipoUsos = null;
    this.catAguaZonas = null;
    this.getAllCatDelegaciones();
    //this.getAllCatColonias();
    this.getAllCatTipoServicios();
    this.getAllCatTipoUsos();
    this.getAllCatAguasZona();
    this.aguaBuscaCuentasForm = this.formBuilder.group({
      id: [undefined],
      cuentaAguaAnterior: [
        undefined,
        // [Validators.pattern(/^[0-9]+\.?[0-9]*$/)],
      ],
      cuentaAgua: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      derivada: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cuentaPredial: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      domicilio: [undefined],
      colonia: [undefined],
      idTipoServicio: [undefined],
      idTipoUso: [undefined],
      idRuta: [undefined],
      cveCatastral: [undefined],
      cveMun: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cveZona: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cveManz: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cveLote: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cveEdif: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cveDepto: [undefined, [Validators.pattern(/^[0-9]+\.?[0-9]*$/)]],
      cliente: [undefined],
      razonSocial: [undefined],
      nombre: [undefined],
      primerApellido: [undefined],
      segundoApellido: [undefined],
      serie: [undefined],
      nombreLocal: [undefined],
    });

    if (this.aguaBuscaCuentas) {
      this.aguaBuscaCuentasForm.patchValue(this.aguaBuscaCuentas);
    }
  }

  async getAllCatColonias() {
    try {
      const datoRetorno = await this.catColoniasService.getAll().toPromise();
      this.catColonias = datoRetorno;
      if(!datoRetorno) return;

      this.catColonias.unshift({
        baja: null,
        cambio: null,
        id: 0,
        descripcion: 'SELECCIONA...',
        idZona: null,
        idDelagacion: null,
        numRow: null, });
      console.log('CatColonia: ', this.catColonias);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getCatColonias');
    }
  }
  // cerr || 04042024 || se agrega metodo para cargar las delegaciones
  async getAllCatDelegaciones() {
    try {
      const datoRetorno = await this.catDelegacionesService.getAll().toPromise();
      this.catDelegaciones = datoRetorno;
      if(!datoRetorno) return;

      this.catDelegaciones.unshift({
        baja: null,
        cambio: null,
        id: 0,
        descripcion: 'SELECCIONA...',
        idMunicipio: null,
        numRow: null, });
      console.log('CatColonia: ', this.catColonias);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getCatColonias');
    }
  }


async getAllCatTipoServicios() {
    try {
      const datoretorno = await this.catTipoServiciosService.getAll().toPromise();
      this.catTipoServicios = datoretorno;
      if(!this.catTipoServicios) return;
      this.catTipoServicios.unshift({
        baja: null,
        cambio: null,
        id: 0,
        descripcion: 'SELECCIONA...',
        abreviatura: null,
        numRow: null, });
     console.log(this.catTipoUsos);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getCatTipoServicios');
    }
  }
  async getAllCatTipoUsos(){
    try{
      const datoretorno = await this.CatTipoUsosService.getAll().toPromise();
      console.log(this.catTipoUsos);
      this.catTipoUsos = datoretorno;
      if(!this.catTipoUsos) return;
      this.catTipoUsos.unshift({
         baja: null,
         cambio: null,
         id: 0,
         descripcion: 'SELECCIONA...',
         abreviatura: null,
         dato: null,
         numRow: null, });
      console.log(this.catTipoUsos);
    }
   catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getAllCatTipoUsos');
    }
  }
  async getAllCatAguasZona(){
    try{
      const datoretorno = await this.catAguaZonasService.getAll().toPromise();
      this.catAguaZonas = datoretorno;
      if(!this.catAguaZonas) return;
      this.catAguaZonas.unshift({
        baja: null,
        cambio: null,
        id: 0,
        descripcion: 'SELECCIONA...',
        numRow: null, });

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getAllCatAguasZona');
    }
  }
  // cerr || 04042024 || se agrega filtro de colonia segun la delegacion seleccionada
  async selectCatDelegaciones(delegacion) {
    if(!delegacion.value) return;
    this.auxDelegacion = delegacion.value.id;
    const datoRetorno = await this.catColoniasService.getSingleDelegacion(delegacion.value.id).toPromise();
      this.catColonias = datoRetorno;
  }
  // cerr || 04042024 || se agrega filtro de calles segun la colonia seleccionada
  async selectOPtionA(colonias) {   
    if(!colonias.value) return;     
    this.auxColonias = colonias.value.descripcion;
    const datoRetorno = await this.catCallesService.getSingleColonias(colonias.value.id).toPromise();
    this.catCalles = datoRetorno;
  }
  // se agrega regreso del drop para agarrar la descripcion de la calle
  async selectCatCalles(calle) {    
    if(!calle.value) return;       
    this.auxCalle = calle.value.id;   
  }
  async selectOPtionB(TipoServicios) {
    this.auxTipoServicios = TipoServicios.value.id;
  }

  async selectOPtionC(TipoUsos) {
    this.auxTipoUsos = TipoUsos.value.id;
  }
  async selectOPtionD(AguaZonas) {
    this.auxAguaZonas = AguaZonas.value.id;
  }
 
  // ====================================================
  // Eventos dataTable
  // ====================================================
  ngAfterViewInit() {
    this.initDatatable();
    if (this.aguaBuscaCuentasInput) {
      this.aguaBuscaCuentasTable = this.aguaBuscaCuentasInput
      this.reInitDatatable();
    }
  }

  private initDatatable(): void {
    const tabla: any = $("#aguaBuscaCuentasTable");
    this.tableWidget = tabla.DataTable({
      scrollX: true,
      destroy: true,
      filter: false,
      "dom": '<"toolbar">frtip',
      language: {
        "sProcessing": "Procesando...",
        "sLengthMenu": "Mostrar _MENU_ registros",
        "sZeroRecords": "No se encontraron resultados",
        "sEmptyTable": "Ningún dato disponible en esta tabla",
        "sInfo": "Registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty": "Registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
        "sInfoPostFix": "",
        "sSearch": "Buscar:",
        "sUrl": "",
        "sInfoThousands": ",",
        "sLoadingRecords": "Cargando...",
        "oPaginate": {
          "sFirst": "Primero",
          "sLast": "Último",
          "sNext": "Siguiente",
          "sPrevious": "Anterior"
        },
        "oAria": {
          "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
          "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        },
        "buttons": {
          "copy": "Copiar",
          "colvis": "Visibilidad"
        }
      }
    });
  }
  private reInitDatatable(): void {
    this.tableWidget.destroy();
    // this.tableWidget = null;
    setTimeout(() => this.initDatatable(), 0);
  }

  recarga() {
    try {
      if (this.aguaBuscaCuentasForm.invalid) {
        throw new Error("No paso las validaciones.");
      }

      this.aguaBuscaCuentas = this.aguaBuscaCuentasForm.value;
      this.aguaBuscaCuentas.colonia = this.auxColonias;
      this.aguaBuscaCuentas.idTipoServicio= this.auxTipoServicios;
      this.aguaBuscaCuentas.idTipoUso = this.auxTipoUsos;
      this.aguaBuscaCuentas.idRuta = this.auxAguaZonas;
      this.aguaBuscaCuentas.idDelegacion = this.auxDelegacion;
      this.aguaBuscaCuentas.idCalle = this.auxCalle;

      //Validar que por lo menos se tenga capturado un criterio de busqueda.

      if (Utils.isEmpty(this.aguaBuscaCuentas.cuentaAgua)) {
        this.aguaBuscaCuentas.cuentaAgua = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.cuentaAguaAnterior)) {
        this.aguaBuscaCuentas.cuentaAguaAnterior = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.derivada)) {
        this.aguaBuscaCuentas.derivada = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.nombre)) {
        this.aguaBuscaCuentas.nombre = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.primerApellido)) {
        this.aguaBuscaCuentas.primerApellido = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.segundoApellido)) {
        this.aguaBuscaCuentas.segundoApellido = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.razonSocial)) {
        this.aguaBuscaCuentas.razonSocial = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.domicilio)) {
        this.aguaBuscaCuentas.domicilio = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.colonia)) {
        this.aguaBuscaCuentas.colonia = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.idTipoServicio)) {
        this.aguaBuscaCuentas.idTipoServicio = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.idTipoUso)) {
        this.aguaBuscaCuentas.idTipoUso = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.idRuta)) {
        this.aguaBuscaCuentas.idRuta = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.serie)) {
        this.aguaBuscaCuentas.serie = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.cuentaPredial)) {
        this.aguaBuscaCuentas.cuentaPredial = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.cveMun)) {
        this.aguaBuscaCuentas.cveMun = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.cveZona)) {
        this.aguaBuscaCuentas.cveZona = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.cveManz)) {
        this.aguaBuscaCuentas.cveManz = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.cveLote)) {
        this.aguaBuscaCuentas.cveLote = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.cveEdif)) {
        this.aguaBuscaCuentas.cveEdif = undefined;
      }
      if (Utils.isEmpty(this.aguaBuscaCuentas.cveDepto)) {
        this.aguaBuscaCuentas.cveDepto = undefined;
      }
      if (
        Utils.isEmpty(this.aguaBuscaCuentas.cuentaAgua) &&
        Utils.isEmpty(this.aguaBuscaCuentas.cuentaAguaAnterior) &&
        Utils.isEmpty(this.aguaBuscaCuentas.derivada) &&
        Utils.isEmpty(this.aguaBuscaCuentas.nombre) &&
        Utils.isEmpty(this.aguaBuscaCuentas.primerApellido) &&
        Utils.isEmpty(this.aguaBuscaCuentas.segundoApellido) &&
        Utils.isEmpty(this.aguaBuscaCuentas.razonSocial) &&
        Utils.isEmpty(this.aguaBuscaCuentas.domicilio) &&
        Utils.isEmpty(this.aguaBuscaCuentas.colonia) &&
        Utils.isEmpty(this.aguaBuscaCuentas.idTipoServicio) &&
        Utils.isEmpty(this.aguaBuscaCuentas.idTipoUso) &&
        Utils.isEmpty(this.aguaBuscaCuentas.idRuta) &&
        Utils.isEmpty(this.aguaBuscaCuentas.serie) &&
        Utils.isEmpty(this.aguaBuscaCuentas.cuentaPredial) &&
        Utils.isEmpty(this.aguaBuscaCuentas.cveMun) &&
        Utils.isEmpty(this.aguaBuscaCuentas.cveZona) &&
        Utils.isEmpty(this.aguaBuscaCuentas.cveManz) &&
        Utils.isEmpty(this.aguaBuscaCuentas.nombreLocal) &&
        Utils.isEmpty(this.aguaBuscaCuentas.idDelegacion) &&
        Utils.isEmpty(this.aguaBuscaCuentas.idCalle) 

      ) {
        console.log("this.aguaBuscaCuentas",this.aguaBuscaCuentas);
        
        throw new Error("Debe capturar por lo menos un criterio de busqueda.");
      }
      if (this.aguaBuscaCuentas.serie != null){
        this.aguaBuscaCuentas.serie = this.aguaBuscaCuentas.serie.toUpperCase();
      }
      this.addAguaBuscaCuentas(this.aguaBuscaCuentas);

      //this.aguasOutput.emit(null);
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por addAguaBuscaCuentas");
    }
  }

  onRowSelect(event) {
    console.log(event.data.id);
    this.selectRow(event.data.id);
  }

  async selectRow(id: number) {
    console.log("Renglon seleccionado:", id);
    //this.limpiar();
    this.getAguas(id);
  }
  clearSelection(dropdown) {    
    dropdown.updateSelectedOption(null);
}

  limpiar($event) {
    this.aguaBuscaCuentasForm.reset();
    this.aguaBuscaCuentasTable = null;
     this.dropDownColonia.clear($event);
     this.dropDownCalle.clear($event);
     this.dropDownDelegacion.clear($event);
     this.dropDownCatServicios.clear($event);
     this.dropDownCatUsos.clear($event);
     this.dropDownRutas.clear($event);
     this.auxColonias = null;
     this.auxCalle = null;
     this.auxDelegacion = null;
     this.auxTipoServicios = null;
     this.auxTipoUsos = null;
     this.auxAguaZonas = null;
    // this.catTipoServicios = null;
    // this.catTipoUsos = null;
    // this.catAguaZonas = null;
    
  
    console.log('limpiar ');

  }

  async imprimir(){
    try{
          this.progressBar = true;
          this.auxJasper = new AuxJasper();
          this.auxJasper.JasperReport.nombreReporte = "030_Busqueda_Personalizada_Usuarios";
          this.auxJasper.JasperReport.tipo = "xlsx";

          //se manejan estos 4 separados porque si los envio junto a los de abajo no muestra nada en el reporte
          const addParameter = (nombre: string, valor: any) => {
            if (valor !== undefined && valor !== null) {
              const parametro = new ParametroJasper();
              parametro.nombre = nombre;
              parametro.valor = valor + "";
              this.auxJasper.ParametroJasper.push(parametro);
            }
          };

          addParameter("_cuenta_anterior", this.aguaBuscaCuentasForm.value.cuentaAguaAnterior);
          addParameter("_nombre_local", this.aguaBuscaCuentasForm.value.nombreLocal);
          addParameter("_cvedifr", this.aguaBuscaCuentasForm.value.cveEdif);
          addParameter("_cvedepto", this.aguaBuscaCuentasForm.value.cveCDepto);
      
         
          let parametros = [
            { nombre: "_cuenta_agua", valor: this.aguaBuscaCuentasForm.value.cuentaAgua != undefined ? this.aguaBuscaCuentasForm.value.cuentaAgua + "" : null}, 
            { nombre: "_derivada", valor: this.aguaBuscaCuentasForm.value.derivada != undefined ? this.aguaBuscaCuentasForm.value.derivada + "" : null},  
            { nombre: "_nombre", valor: this.aguaBuscaCuentasForm.value.nombre != undefined ? this.aguaBuscaCuentasForm.value.nombre + "" : null},  
            { nombre: "_domicilio", valor: this.aguaBuscaCuentasForm.value.domicilio != undefined ? this.aguaBuscaCuentasForm.value.domicilio + "" : null},
            { nombre: "_id_delegacion", valor: this.aguaBuscaCuentasForm.value.idDelegacion != undefined ? this.aguaBuscaCuentasForm.value.idDelegacion + "" : null}, 
            { nombre: "_colonia", valor: this.aguaBuscaCuentas.colonia != undefined ? this.aguaBuscaCuentas.colonia + "" : null},
            { nombre: "_id_calle", valor: this.aguaBuscaCuentasForm.value.idCalle != undefined ? this.aguaBuscaCuentasForm.value.idCalle + "" : null},
            { nombre: "_id_tipo_servicio", valor: this.aguaBuscaCuentasForm.value.idTipoServicio != undefined ? this.aguaBuscaCuentasForm.value.idTipoServicio + "" : null},
            { nombre: "_id_tipo_uso", valor: this.aguaBuscaCuentasForm.value.idTipoUso != undefined ? this.aguaBuscaCuentasForm.value.idTipoUso + "" : null},
            { nombre: "_id_ruta", valor: this.aguaBuscaCuentasForm.value.idRuta != undefined ? this.aguaBuscaCuentasForm.value.idRuta + "" : null},
            { nombre: "_serie", valor: this.aguaBuscaCuentasForm.value.serie != undefined ? this.aguaBuscaCuentasForm.value.serie + "" : null},
            { nombre: "_cuenta_predial", valor: this.aguaBuscaCuentasForm.value.cuentaPredial != undefined ? this.aguaBuscaCuentasForm.value.cuentaPredial + "" : null},
            { nombre: "_cvemun", valor: this.aguaBuscaCuentasForm.value.cveMun != undefined ? this.aguaBuscaCuentasForm.value.cveMun + "" : null},
            { nombre: "_cvezona", valor: this.aguaBuscaCuentasForm.value.cveZona != undefined ? this.aguaBuscaCuentasForm.value.cveZona + "" : null},
            { nombre: "_cvemanz", valor: this.aguaBuscaCuentasForm.value.cveManz != undefined ? this.aguaBuscaCuentasForm.value.cveManz + "" : null},
            { nombre: "_cvelote", valor: this.aguaBuscaCuentasForm.value.cveLote != undefined ? this.aguaBuscaCuentasForm.value.cveLote + "" : null}
          ];
          
          parametros.forEach(param => {
            const p = new ParametroJasper();
            p.nombre = param.nombre;
            p.valor = param.valor;
            this.auxJasper.ParametroJasper.push(p);
          });
        
        } catch (e) {
          this.muestraMensaje.error(e.message, "top", "center");
        } finally {
            console.log('Paso por imprimeSolicitud');
            //this.aguaBuscaCuentasForm.reset();
            setTimeout(() => {
              this.progressBar = false;
              this.btnImprimir= false;
              this.aguaBuscaCuentasForm.reset();
            },5000)
      }
  }

  async getAguas(id: number) {
    try {
      //const datoRetorno = await this.aguasService.getSingle(id).toPromise();
      console.log("Va a emitir");
      //this.aguasOutput.emit(datoRetorno);
      this.aguasOutput.emit(id);
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getAguas");
    }
  }

  async addAguaBuscaCuentas(aguaBuscaCuentas) {
    if (this.buscando) {
      return;
    }
    try {

      this.buscando = true;
      const datoretorno = await this.aguaBuscaCuentasService
        .add(aguaBuscaCuentas)
        .toPromise();
      this.aguaBuscaCuentasTable = datoretorno;
      console.log(this.aguaBuscaCuentasTable);
      if (this.aguaBuscaCuentasTable[0] == null) {
        //this.aguaBuscaCuentasForm.reset();
        this.muestraMensaje.error("No se encontró registro.", "top", "center");
      }
      else {
        this.reInitDatatable();
      }
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por addAguaBuscaCuentas");
      this.buscando = false;
      this.btnImprimir = true;
    }
  }
}